import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'components.SMSCode.placeholder',
    defaultMessage: 'Please enter code',
    description: '短信验证码placeholder',
  },
  getCode: {
    id: 'components.SMSCode.getCode',
    defaultMessage: 'Send',
    description: '获取验证码',
  },
  errorMsg: {
    id: 'components.SMSCode.errorMsg',
    defaultMessage: 'SMS Code must be a 6 digit number',
    description: '获取验证码格式报错',
  },
})
